var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForemanSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6646 22.0005C37.2902 22.0005 41.8506 21.3657 41.8506 20.5826C41.8506 19.7996 37.2902 19.1648 31.6646 19.1648C26.039 19.1648 21.4785 19.7996 21.4785 20.5826C21.4785 21.3657 26.039 22.0005 31.6646 22.0005Z",
    fill: "#EF8B06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8527 51.8496H14.7126L16.2549 39.1388C16.5036 37.1488 17.7722 35.42 19.6129 34.6116C22.0506 33.5545 25.4459 32.4724 28.4557 31.6516L35.3086 31.6267C38.3433 32.4476 41.6391 33.5296 44.0022 34.5992C45.8056 35.42 47.0493 37.1239 47.2981 39.089L48.8527 51.8496Z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4702 28.3557V31.7511C35.4702 31.7511 34.7986 35.5444 31.652 36.1787C28.3686 35.3205 27.8711 31.7511 27.8711 31.7511V28.3557H35.4702Z",
    fill: "#F7CFA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6294 23.9282C39.4743 23.9282 40.1592 23.1041 40.1592 22.0875C40.1592 21.0709 39.4743 20.2468 38.6294 20.2468C37.7845 20.2468 37.0996 21.0709 37.0996 22.0875C37.0996 23.1041 37.7845 23.9282 38.6294 23.9282Z",
    fill: "#F7CFA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9236 23.7788C25.7684 23.7788 26.4533 22.9547 26.4533 21.9381C26.4533 20.9215 25.7684 20.0974 24.9236 20.0974C24.0787 20.0974 23.3938 20.9215 23.3938 21.9381C23.3938 22.9547 24.0787 23.7788 24.9236 23.7788Z",
    fill: "#F7CFA4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8711 29.8606C28.9531 31.0422 30.2839 31.8257 31.7142 31.8257C33.1071 31.8257 34.4006 31.0795 35.4702 29.9477V28.3682H27.8711V29.8606Z",
    fill: "#E2AA6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0605 19.6621V22.0874C25.0605 25.7688 28.0455 30.9675 31.7269 30.9675C35.4083 30.9675 38.3932 25.7688 38.3932 22.0874V19.6621H25.0605Z",
    fill: "#F7CFA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9451 41.7881H20.6079V51.8622H42.9451V41.7881Z",
    fill: "#FFB600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5248 44.9968H24.0281V51.8497H39.5248V44.9968Z",
    fill: "#FF8B00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.023 41.7878V32.6589C24.0778 32.9574 23.145 33.2684 22.262 33.5793V41.7878H25.023Z",
    fill: "#FFB600"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.378 41.788V33.5421C40.495 33.2188 39.5622 32.8954 38.6169 32.5969V41.788H41.378Z",
    fill: "#FFB600"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5034 20.4955H41.9004C41.689 20.2219 40.8059 19.1025 39.8856 18.7294C39.8856 18.7294 40.3209 9.74979 31.7268 9.56323H31.7143H31.7019C23.1078 9.74979 23.5431 18.7294 23.5431 18.7294C22.5855 19.1025 21.7024 20.2219 21.5034 20.4955Z",
    fill: "#FFB600"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5288 14.8845V16.4677H31.7162V17.6551L33.7392 15.6321H32.5078L34.5748 13.6091L30.5288 14.8845Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5059,
    y: 36.0459,
    width: 38.6207,
    height: 18.3908,
    fill: "url(#paint0_linear_5001_20025)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5001_20025",
    x1: 31.8162,
    y1: 36.0459,
    x2: 31.8162,
    y2: 54.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForemanSmall);
export default __webpack_public_path__ + "static/media/foremanSmall.b19ae50aeab65e8e7f62aa83d1f1bdd0.svg";
export { ForwardRef as ReactComponent };